<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12>"
        class="
          align-center
          color-suva-grey
          d-flex
          empty-state-view-height
          font-size-lg
          justify-center
        "
      >
        <slot>Empty</slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "EmptyState",
};
</script>

<style scoped>
.empty-state-view-height {
  height: calc(100vh - 617px);
  min-height: 205px;
}
/* footer is 360px tall */
/* header is 152px tall */
/* title is  105px tall */
</style>
